import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  return (<div className="footer-div">
    <Fade>
      <p className="footer-text" style={{ color: props.theme.secondaryText }}>
        <a
          href="https://senthvyra.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: props.theme.secondaryText, textDecoration: 'none' }}
        >
          Senth Vyra <span role="img" aria-label="dot"></span>
        </a>
      </p>
    </Fade>
  </div>
  
    // <div className="footer-div">
    //   <Fade>
    //         <p className="footer-text" style={{ color: props.theme.secondaryText }}>
    //       Thulax.Online <span role="img">.</span>
    //     </p>
    //     {/* <p className="footer-text" style={{ color: props.theme.secondaryText }}>
    //       Made with <span role="img">❤️</span> by {greeting.title2}
    //     </p> */}
        
    //   </Fade>
    // </div>
  );
}
